<template>
    <div class="account-member">
        <base-divider text="修改密码"/>
        <div class="form">
            <el-form :model="formData" :rules="rules" ref="form" label-width="120px">
                <el-form-item label="账号:">
                    <el-input :value="userInfo.phone" placeholder="请输入旧密码" disabled></el-input>
                </el-form-item>

                <template v-if="validEdit">
                    <el-form-item label="新密码:" prop="password">
                        <el-input
                                v-model="formData.password"
                                placeholder="6位以上数字和字母组合密码"
                                prefix-icon="el-icon-key"
                        ></el-input>
                    </el-form-item>

                    <el-form-item label="确认新密码:" prop="confirmPassword">
                        <el-input
                                v-model="formData.confirmPassword"
                                placeholder="再次输入新密码"
                                prefix-icon="el-icon-key"
                        ></el-input>
                    </el-form-item>

                    <el-form-item label="验证码:" prop="smsCode">
                        <div class="code">
                            <span>
                                <el-input
                                        v-model="formData.smsCode"
                                        placeholder="请输入验证码"
                                        type="number"
                                        :maxlength="6"
                                        oninput="if(value.length>4)value=value.slice(0,4)"
                                ></el-input>
                            </span>
                            <el-button @click="getSmsCode">{{codeText}}</el-button>
                        </div>
                    </el-form-item>
                </template>

                <el-form-item>
                    <template>
                        <el-button v-if="validEdit" @click="validEdit = false">取消</el-button>
                        <el-button type="primary" @click="validEdit = true" v-else>编辑</el-button>
                    </template>

                    <el-button type="primary" @click="updatePassword" v-if="validEdit" :loading="loading">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {getSmsCode, updatePassword} from '@/http/request'
    import BaseDivider from '@/components/BaseDivider/BaseDivider'

    export default {
        name: "AccountMember",
        components: {BaseDivider},
        computed: {
            ...mapState(['userInfo']),
            codeText() {
                if (this.startDown) {
                    return `${this.countDown}s`
                } else {
                    return '获取验证码'
                }
            },

            rules() {
                // 自定义规则校验验证码
                const validateSmsCode = (rule, value, callback) => {
                    if (!value) {
                        return callback(new Error('验证码不能为空'))
                    }

                    const len = value.toString().length;
                    if (len !== 4) {
                        return callback(new Error('验证码长度不正确'))
                    }
                    callback()
                }

                // 密码校验
                const validatePassword = (rule, value, callback) => {
                    if (!value) {
                        return callback(new Error('密码不能为空'))
                    }

                    if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/.test(value)) {
                        return callback(new Error('密码格式不正确'))
                    }

                    // 输入密码后如果确认密码栏有值进行校验
                    if (this.formData.confirmPassword) {
                        this.$refs['form'].validateField('confirmPassword')
                    }

                    callback()
                }

                // 确认密码校验
                const validateConfirmPassword = (rule, value, callback) => {
                    if (!value) {
                        return callback(new Error('确认密码不能为空'))
                    }

                    if (value !== this.formData.password) {
                        return callback(new Error('两次密码不一致'))
                    }
                    callback();
                }

                return {
                    password: [
                        {validator: validatePassword, trigger: "blur"}
                    ],
                    confirmPassword: [
                        {validator: validateConfirmPassword, trigger: 'blur'}
                    ],
                    smsCode: [
                        {validator: validateSmsCode, trigger: 'blur'}
                    ]
                }
            }
        },
        data() {
            return {
                formData: {
                    password: "",
                    phone: "",
                    smsCode: ""
                },
                loading: false,
                validEdit: false, // 是否可编辑
                startDown: false,
                countDown: 0,
                timer: null
            }
        },
        methods: {
            // 获取验证码
            getSmsCode() {
                getSmsCode(this.userInfo.phone, 2).then(({data}) => {
                    if (data.code === 0) {
                        // 开启倒计时
                        this.startDown = true;
                        this.countDown = 60;
                        this.timer = setInterval(() => {
                            this.countDown--;
                            if (this.countDown < 0) {
                                clearInterval(this.timer);
                                this.countDown = 0;
                                this.startDown = false;
                            }
                        }, 1000)
                    } else {
                        this.$message({
                            type: 'error',
                            message: data.msg
                        })
                    }
                })
            },

            // 保存修改
            updatePassword() {
                const that = this;
                this.loading = true;
                this.$refs.form.validate(valid => {
                    if (valid) {
                        updatePassword({...this.formData, phone: this.userInfo.phone}).then(({data}) => {
                            this.loading = false;
                            if (data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: '修改密码成功',
                                    onClose() {
                                        that.validEdit = false;
                                    }
                                })
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: data.msg
                                })
                            }
                        }).catch(() => {
                            this.loading = false;
                            this.$message({
                                type: 'error',
                                message: '修改密码失败'
                            })
                        })
                    }
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .account-member {
        .form {
            width: 400px;
            margin-top: 50px;
            .code {
                width: 100%;
                display: flex;

                span {
                    flex: 1;
                }

                button {
                    margin-left: 5px;
                    background: #f1f2f2;
                    border: none;
                    color: #999999;
                    font-weight: 400;
                }
            }
        }
    }
</style>